"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m4.78 4.73 4.64 2.28 2.84 1.4.96.47L19.58 12l-6.36 3.12-1.25.61-2.55 1.25-4.64 2.28c3.12-6.33 3.12-6.8 3.12-7.27 0-.46 0-.94-3.12-7.27M1.41 1c-.45 0-.55.39-.2 1.06 0 0 4.69 9.32 4.69 9.94 0 .62-4.69 9.94-4.69 9.94-.35.67-.25 1.06.2 1.06.2 0 .46-.07.78-.23l8.11-3.98c1.27-.617 2.536-1.24 3.8-1.87l8.11-3.98c1.05-.51 1.05-1.35 0-1.87L14.1 7.09a446.53 446.53 0 0 1-3.8-1.87L2.19 1.23C1.87 1.07 1.61 1 1.41 1Z"
  })]
});